<template>
  <div class="table-panel flex flex-wrap">
    <div v-for="(v, i) in tableConditions" :key="i" class="mb10">
      <template class="flex flex-wrap item-center">
        <span
          v-if="v.isRequiredWhere === 'yes'"
          class="danger hmicon icon-xinghao"
        ></span>
        <template v-if="v.columnType === 'datetime'">
          <el-date-picker
            v-if="v.queryMode === 'range'"
            v-model="v.applyDate"
            type="daterange"
            align="right"
            style="width:212px"
            :default-time="['00:00:00', '23:59:59']"
            :start-placeholder="v.labelName"
            :end-placeholder="v.labelName"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            clearable
            :picker-options="pickerOptions"
          ></el-date-picker>
          <template v-else>
            <el-date-picker
              clearable
              style="width:200px"
              v-if="v.columnType === 'datetime'"
              v-model="v.queryValue"
              type="date"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              :placeholder="v.labelName"
            ></el-date-picker>
          </template>
          <el-tooltip class="item" effect="dark" placement="right">
            <div slot="content">
              {{ v.labelName }}{{ v.isRequiredWhere === "yes" ? "(必填)" : "" }}
            </div>
            <i class="el-icon-info mr20"></i>
          </el-tooltip>
        </template>
        <template v-else>
          <!-- {{ v.labelName }} -->
          <el-select
            clearable
            v-if="v.isSelect && v.isMultiple"
            size="small"
            style="width:200px"
            :placeholder="v.labelName"
            v-model="v.queryListValue"
            :multiple="v.isMultiple"
          >
            <el-option
              v-for="(v, i) in v.selectList"
              :key="i"
              :label="v.text"
              :value="v.value"
            ></el-option>
          </el-select>
          <el-select
            clearable
            v-if="v.isSelect && !v.isMultiple"
            size="small"
            style="width:200px"
            :placeholder="v.labelName"
            v-model="v.queryValue"
            :multiple="v.isMultiple"
          >
            <el-option
              v-for="(v, i) in v.selectList"
              :key="i"
              :label="v.text"
              :value="v.value"
            ></el-option>
          </el-select>
          <template v-if="v.queryMode === 'range'">
            <el-input
              style="width:90px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="v.queryStartValue"
              :placeholder="v.labelName"
            ></el-input>
            <el-input
              style="width:90px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="v.queryEndValue"
              :placeholder="v.labelName"
            ></el-input>
          </template>

          <el-input
            v-if="v.queryMode === 'equal' || v.queryMode === 'like'"
            style="width:200px"
            size="small"
            clearable
            class="mr10 ipt"
            v-model.trim="v.queryValue"
            :placeholder="v.labelName"
          ></el-input>
          <el-tooltip class="item" effect="dark" placement="right">
            <div slot="content">
              {{ v.labelName }}{{ v.isRequiredWhere === "yes" ? "(必填)" : "" }}
            </div>
            <i class="el-icon-info mr20"></i>
          </el-tooltip>
        </template>
      </template>
    </div>
    <div v-if="tableConditions.length">
      <el-button type="primary" size="small" @click="search" :loading="loading"
        >生成报表</el-button
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    configId: {
      type: String,
      default: ""
    },
    tableConditions: {
      type: Array,
      default: () => []
    },
    tableHeader: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      tableList: [],
      id: "",
      reportsList: [],
      dialogVisible: false,
      tableOption: {
        border: true,
        height: 500,
        maxHeight: 500
      },
      tableDatas: [],
      selectDate: "",
      //日期选择范围在一个月内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: time => {
          if (this.selectDate !== "") {
            const one = this.days * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      days: 30,
      activeName: "second",
      searchList: [],
      isCollapse: false,
      activeIndex: "1",
      coypColList: [],
      col: [
        {
          labelName: "日期",
          columnName: "date"
        },
        {
          labelName: "姓名",
          columnName: "name"
        },
        {
          labelName: "地址",
          columnName: "address"
        }
      ],
      dropCol: [
        {
          labelName: "日期",
          columnName: "date"
        },
        {
          labelName: "姓名",
          columnName: "name"
        },
        {
          labelName: "地址",
          columnName: "address"
        }
      ],
      tableData: [],
      copyTableData: [],
      tableGroup: [],
      searchTip: "",
      tableHeaderTip: "",
      tableOperationTip: "",
      isAct: false,
      resultId: "",
      isOutputing: false,
      row: {}
    };
  },
  computed: mapState({
    customTableHeaderData: state => state.reportCenter.customTableHeaderData
  }),
  created() {},
  mounted() {},
  methods: {
    search() {
      this.$emit("search");
    }
  }
};
</script>

<style scoped lang="scss">
.table-panel {
  background: #fff;
}
</style>
